import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Button } from '@/design-system/ui/Button';
import { EmptyState } from '@/design-system/ui/States';
import { useAuthStore } from '../model/auth-store';

/** Route guard: shows an inline prompt and opens the login sheet instead of redirecting away. */
export function RequireAuth({ title = 'برای ادامه وارد شوید' }: { title?: string }) {
  const token = useAuthStore((s) => s.accessToken);
  const openLogin = useAuthStore((s) => s.openLogin);
  useEffect(() => {
    if (!token) openLogin();
  }, [token, openLogin]);

  if (token) return <Outlet />;
  return (
    <EmptyState
      title={title}
      description="با شماره موبایل خود وارد شوید تا بتوانید ادامه دهید."
      action={<Button onClick={() => openLogin()}>ورود به حساب کاربری</Button>}
    />
  );
}
